module.exports = __webpack_public_path__ + "static/media/abdulBasir.47917828.png";